import { getInformationProtectionStrings } from './stringTypes/InformationProtectionStrings';
import { stringTableFetcher } from './stringTableFetcher.dynamic';
export function getStringTable(locale) {
    return getInformationProtectionStrings(stringTableFetcher, locale);
}
